import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedResourceToRemove } from 'store/organizationCharts/selectors/organizationChart.selectors';
import { patchRemoveResourceFromProject } from '../services/patchRemoveResoureFromProject.service';

export const removeResourceFromProject = createAsyncThunk(
  'resources/removeResourceFromProject',
  async (_, { getState }) => {
    const selectedResourceToRemove = selectSelectedResourceToRemove(getState());

    const { project, id } = selectedResourceToRemove;

    const response = await patchRemoveResourceFromProject(project, id);
    return response;
  }
);
